module.exports = __webpack_public_path__ + "img/idc_datacenter_pic04.4a1d51ca.jpg";